export const getAPIUrl = () => {
  return (window as any).env?.API_URL || process.env.REACT_APP_API_UR;
};

export const getGoogleMapsApiKey = () => {
  return (window as any).env?.GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
};
